import {
  ORDER_PLACED_LOADED,
  TOGGLE_ORDER_SUMMARY,
  RESET_ORDER_PLACED_TOAST,
  SET_ORDER_PLACED_DASHBOARD_TOAST,
  DETERMINE_NRSF,
  DETERMINE_CONTRACT_TO_CR,
  DETERMINE_CONTRACT_TO_CR_PHASE_2,
  GET_PAYMENT_SUMMARY
} from './action-types';

const orderPlacedState = {
  isLoading: false,
  hasLoaded: false,
  showOrderSummary: false,
  toastMessage: null,
  isNRSF: false,
  isContractToCR: false,
  isContractToCRPhase2: false,
  paymentSummary: {
    hasLoaded: false
  }
};

export default function reducer(state = orderPlacedState, action) {
  const { type, payload } = action;

  switch (type) {
    case `${ORDER_PLACED_LOADED}`:
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        showOrderSummary: false
      };

    case `${TOGGLE_ORDER_SUMMARY}`:
      return {
        ...state,
        showOrderSummary: !state.showOrderSummary
      };

    case `${RESET_ORDER_PLACED_TOAST}`:
      return {
        ...state,
        toastMessage: null
      };

    case `${SET_ORDER_PLACED_DASHBOARD_TOAST}`:
      return {
        ...state,
        toastMessage: payload
      };

    case `${DETERMINE_NRSF}_SUCCESS`:
      return {
        ...state,
        isNRSF: payload
      };

    case `${DETERMINE_CONTRACT_TO_CR}_SUCCESS`:
      return {
        ...state,
        isContractToCR: payload
      };

    case `${DETERMINE_CONTRACT_TO_CR_PHASE_2}_SUCCESS`:
      return {
        ...state,
        isContractToCRPhase2: payload
      };

    case `${GET_PAYMENT_SUMMARY}_SUCCESS`:
      return {
        ...state,
        paymentSummary: {
          hasLoaded: true,
          ...payload
        }
      };

    default:
      return state;
  }
}
